module.exports = __webpack_public_path__ + "static/nick-f129cf3e20321f454ad785b5abd209ff.jpeg";